import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { useTheme } from '../../../contexts/ThemeContext';
import CircleCheck from '../../icons/CircleCheck';
import CircleInvalid from '../../icons/CircleInvalid';
import Accordion from '../../partials/Accordion';

import styles from '../../../../styles/items/question-result-exam.module.css';

export interface QuestionResultProps {
    index: number;
    question: Question;
    answer: ParticipationAnswer | null;
    withExplanation?: boolean;
    withNumber?: boolean;
    className?: string;
}

function ExamQuestionResult({
    index,
    question,
    answer,
    withExplanation = false,
    withNumber = true,
    className,
}: QuestionResultProps) {
    const { name: theme } = useTheme();
    const { id, validAnswer = null, explanation = null, body = null, choices = null } = question;
    const validChoice = (choices || []).find(({ id: choiceId }) => choiceId === validAnswer);
    const { label: validChoiceLabel = null } = validChoice || {};
    const { valid, value: userAnswer } = answer || {};
    const userChoice = (choices || []).find(({ id: choiceId }) => choiceId === userAnswer);
    const { label: userChoiceLabel = null } = userChoice || {};
    const number = (index + 1).toString().padStart(2, '0');
    const finalValidAnswer = validChoiceLabel || validAnswer;
    const finalUserAnswer = userChoiceLabel || userAnswer;

    return (
        <div
            key={`question-${id}`}
            className={classNames([
                styles.container,
                {
                    [styles.valid]: valid === true,
                    [styles.invalid]: valid === false,
                },
                className,
            ])}
        >
            {withNumber ? <span className={styles.number}>{number}</span> : null}
            {valid ? (
                <CircleCheck className={styles.validIcon} />
            ) : (
                <CircleInvalid className={styles.validIcon} />
            )}
            <Accordion
                label={<div className={styles.body}>{body}</div>}
                className={styles.accordion}
                buttonClassName={styles.button}
                contentClassName={styles.content}
                iconClassName={styles.icon}
            >
                <div className={styles.answer}>
                    <FormattedMessage
                        defaultMessage="Your answer: <strong>{answer}</strong>"
                        description="Question result label"
                        values={{
                            answer: finalUserAnswer,
                        }}
                    />
                </div>
                {!valid ? (
                    <div className={styles.answer}>
                        <FormattedMessage
                            defaultMessage="Valid answer: <strong>{answer}</strong>"
                            description="Question result label"
                            values={{
                                answer: finalValidAnswer,
                            }}
                        />
                    </div>
                ) : null}
                {withExplanation && explanation !== null ? (
                    <div className={styles.explanation}>{explanation}</div>
                ) : null}
            </Accordion>
        </div>
    );
}

export default ExamQuestionResult;
